
import { supabase } from '@/integrations/supabase/client';
import { withErrorHandling } from '../utils/errorHandling';

/**
 * Service for generating and managing recipe tags
 */
export const recipeTagService = {
  /**
   * Generate tags for a recipe using OpenAI
   */
  generateTagsForRecipe: withErrorHandling(
    async (recipeId: string, title: string, ingredientsList: string[], instructions: string) => {
      console.log('Generating tags for recipe:', recipeId);
      
      const { data, error } = await supabase.functions.invoke('generate-recipe-tags', {
        body: {
          title,
          ingredients: ingredientsList,
          instructions
        }
      });

      if (error) {
        console.error('Error calling tag generation function:', error);
        return;
      }

      const generatedTags = data?.tags || [];
      console.log('Generated tags:', generatedTags);

      if (generatedTags.length > 0) {
        const { error: updateError } = await supabase
          .from('recipes')
          .update({ tags: generatedTags })
          .eq('id', recipeId);

        if (updateError) {
          console.error('Error updating recipe tags:', updateError);
        } else {
          console.log('Successfully updated recipe with generated tags:', generatedTags);
        }
      }
    },
    "Error generating recipe tags"
  )
};
